import { css } from '@/styled-system/css';

export const scrollAlertWindowMobileStyles = css.raw({
  position: 'absolute',
  top: '20px',
  left: 'calc(50% - 104px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '208px',
  width: '208px',
  borderRadius: '100',
  backgroundColor: 'rgba(42, 42, 51, 0.9)',
});

export const buttonsContainerStyles = css.raw({
  height: 'inherit',
  minWidth: '1200',
  textAlign: 'center',
});

export const buttonsStyles = css.raw({
  position: 'relative',
  top: '56px',
  cursor: 'pointer',
});

export const homeButtonStyles = css.raw({
  position: 'relative',
  textAlign: 'center',
  cursor: 'pointer',
  top: '24px',
});

export const mobileHomeButtonLeftStyles = css.raw({
  position: 'absolute',
  textAlign: 'center',
  top: '-58px',
  left: '24px',
  cursor: 'pointer',
});

export const mobileHomeButtonRightStyles = css.raw({
  position: 'absolute',
  textAlign: 'center',
  top: '-58px',
  right: '24px',
  cursor: 'pointer',
});
